module.exports = __webpack_public_path__ + "media/images/icon/newwindow-white-f578e9c0cddafd518a14cc1bce98ee9b.png";